import { useState } from "react";
import {
  getArticles,
  createArticle,
  updateArticle,
  deleteArticle,
  getArticleById,
} from "api/article.api";

export const useArticles = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadArticles = async () => {
    setLoading(true);
    const company_id = localStorage.getItem("company_id");
    const res = await getArticles({ company_id });
    setData(res.data.data || []);
    setLoading(false);
  };

  const loadArticleById = async (id) => {
    const res = await getArticleById(id);
    return res.data;
  };

  const addArticle = async (payload) => {
    return await createArticle(payload);
  };

  const editArticle = async (id, payload) => {
    return await updateArticle(id, payload);
  };

  const removeArticle = async (id) => {
    await deleteArticle(id);
    loadArticles();
  };

  return {
    data,
    loading,
    loadArticles,
    loadArticleById,
    addArticle,
    editArticle,
    removeArticle,
  };
};
